import env from 'config/build'

export const APP_VERSION = env?.appVersion
